import React from 'react';
import { render } from 'react-dom';
import { getATLContextDomain } from '@atlassian/atl-context';
import Heartbeat, { HeartbeatNew } from '@atlassian/heartbeat';
import AppBase from '@atlassian/jira-app-base';
import { provideHealthcheck } from '@atlassian/jira-common-healthcheck';
import { JiraContextContainer } from '@atlassian/jira-context-container';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import { StrictMode } from '@atlassian/jira-react-strict-mode';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller';

provideHealthcheck();

const container = document.createElement('div');
container.id = 'heartbeat';
document.body && document.body.appendChild(container);

const redirect = (): void => {
	const identity = getATLContextDomain('id');

	const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(
		window.location.href,
	)}`;

	window.location.assign(redirectUrl);
};

const HeartbeatComponent = componentWithFF(
	'platform.mdt-zora.use-heartbeat-singleton_vzod3',
	() => <HeartbeatNew />,
	() => <Heartbeat onAuthenticationFailed={redirect} />,
);

render(
	<StrictMode>
		<JiraContextContainer>
			<TenantContextSubscriber>
				{({ tenantContext: { isAnonymous } }) =>
					!isAnonymous && (
						<AppBase id="heartbeat">
							<HeartbeatComponent />
						</AppBase>
					)
				}
			</TenantContextSubscriber>
		</JiraContextContainer>
	</StrictMode>,
	container,
);
